import React from 'react';
import '../styles/Modal.css';

const Modal = ({ visible, title, message, onCancel, onConfirm }) => {
  if (!visible) return null;

  return (
    <div className={`modal ${visible ? 'active' : ''}`}>
      <div className="modal-content">
        <h3 className="modal-title">{title}</h3>
        <p className="modal-text">{message}</p>
        <div className="modal-actions">
          <button className="modal-btn cancel-btn" onClick={onCancel}>
            取消
          </button>
          <button className="modal-btn confirm-btn" onClick={onConfirm}>
            确定
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
